module.exports = __webpack_public_path__ + "img/carnetB.b1b94b5f.webp";